// @ts-strict-ignore
import React from 'react';
import NumberInputWithSymbol from '~/components/inputs/NumberInputWithSymbol';

export interface TimeframeNumberInputProps {
  minValue: number;
  maxValue: number;
  value: React.ComponentProps<typeof NumberInputWithSymbol>['value'];
  onHandleValueChange: (value: number) => void;
  className?: string;
}

/**
 * Integer-only number input for timeframe "from" / "to" (e.g. aggregation criteria).
 * Wraps NumberInputWithSymbol with type="count". Accepts className so styled() can target this wrapper.
 */
const TimeframeNumberInput = ({
  minValue,
  maxValue,
  value,
  onHandleValueChange,
  className,
}: TimeframeNumberInputProps) => (
  <span className={className} data-timeframe-number-input>
    <NumberInputWithSymbol
      type="count"
      minValue={minValue}
      maxValue={maxValue}
      value={value}
      onHandleValueChange={onHandleValueChange}
    />
  </span>
);

export default TimeframeNumberInput;
